import { render } from "./TabletPreviewModal.vue?vue&type=template&id=4e154230&scoped=true&ts=true"
import script from "./TabletPreviewModal.vue?vue&type=script&lang=ts"
export * from "./TabletPreviewModal.vue?vue&type=script&lang=ts"

import "./TabletPreviewModal.vue?vue&type=style&index=0&id=4e154230&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e154230"]])

export default __exports__